import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.map";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.object.to-string";
import "core-js/modules/web.dom-collections.iterator";
import _slicedToArray from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _createForOfIteratorHelper from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _classCallCheck from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/createClass";
import _createSuper from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/createSuper";
import _inherits from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/inherits";
import { __decorate } from "tslib";
import Vue from 'vue';
import { Component, Prop, Emit, Watch } from 'vue-property-decorator';

var AppListSelector = /*#__PURE__*/function (_Vue) {
  _inherits(AppListSelector, _Vue);

  var _super = _createSuper(AppListSelector);

  function AppListSelector() {
    var _this;

    _classCallCheck(this, AppListSelector);

    _this = _super.apply(this, arguments);
    _this.model = [];
    _this.options = [];
    return _this;
  }

  _createClass(AppListSelector, [{
    key: "mounted",
    value: function mounted() {
      var options = [];

      var _iterator = _createForOfIteratorHelper(this.items.entries()),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _step$value = _slicedToArray(_step.value, 2),
              i = _step$value[0],
              v = _step$value[1];

          options.push({
            index: i,
            selected: false,
            value: v
          });
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      this.value.map(function (val) {
        options[val].selected = true;
      });
      this.options = options;
      this.model = this.value;
    }
  }, {
    key: "onItemsChanged",
    value: function onItemsChanged(val) {
      var options = [];

      var _iterator2 = _createForOfIteratorHelper(val.entries()),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _step2$value = _slicedToArray(_step2.value, 2),
              i = _step2$value[0],
              v = _step2$value[1];

          options.push({
            index: i,
            selected: false,
            value: v
          });
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      this.value.map(function (val) {
        options[val].selected = true;
      });
      this.options = options;
    }
  }, {
    key: "valueChangedHandler",
    value: function valueChangedHandler() {
      return this.model;
    }
  }, {
    key: "addOption",
    value: function addOption(index) {
      this.options[index].selected = true;
      this.model.push(index);
      this.valueChangedHandler();
    }
  }, {
    key: "addOptionAll",
    value: function addOptionAll() {
      var options = this.options;
      var model = [];
      var length = options.length;

      for (var i = 0; i < length; i++) {
        options[i].selected = true;
        model.push(i);
      }

      this.model = model;
      this.options = options;
      this.valueChangedHandler();
    }
  }, {
    key: "removeOption",
    value: function removeOption(index) {
      this.options[index].selected = false;
      this.model = this.$R.without([index], this.model);
      this.valueChangedHandler();
    }
  }, {
    key: "removeOptionAll",
    value: function removeOptionAll() {
      var options = this.options;
      var length = options.length;

      for (var i = 0; i < length; i++) {
        options[i].selected = false;
      }

      this.model = [];
      this.options = options;
      this.valueChangedHandler();
    }
  }, {
    key: "selected",
    get: function get() {
      return this.options.filter(function (opt) {
        return opt.selected;
      });
    }
  }, {
    key: "unSelected",
    get: function get() {
      return this.options.filter(function (opt) {
        return !opt.selected;
      });
    }
  }]);

  return AppListSelector;
}(Vue);

__decorate([Prop({
  type: Array
})], AppListSelector.prototype, "value", void 0);

__decorate([Prop(String)], AppListSelector.prototype, "label", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], AppListSelector.prototype, "required", void 0);

__decorate([Prop({
  type: [Number, String],
  default: 289
})], AppListSelector.prototype, "width", void 0);

__decorate([Prop({
  type: [Number, String],
  default: 36
})], AppListSelector.prototype, "height", void 0);

__decorate([Prop({
  type: Array
})], AppListSelector.prototype, "items", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], AppListSelector.prototype, "disabled", void 0);

__decorate([Watch('items', {
  deep: true
})], AppListSelector.prototype, "onItemsChanged", null);

__decorate([Emit('input')], AppListSelector.prototype, "valueChangedHandler", null);

AppListSelector = __decorate([Component({})], AppListSelector);
export default AppListSelector;